/* =================
 * STICKY HEADER
 * über complex sticky header
 * crazy stuff courtesy of design
 * =================
 */

import { debounce } from "underscore";


export class Stickyheader {
    // staff
    doc = $(document);
    win = $(window);
    body;
    header;

    // request animation frame thread id
    rafId;

    // initials
    lastPosition = 0;
    headerOffsetY = 0;
    headerHeight = 0;
    offsetUpY = 0;
    offsetDownY = 0;

    // flags: stoped (lock and unlock)
    // sticked! state
    stoped = false;
    pinned = false;

    // options: offset delta margin
    offset = 25;

    listening = false;

    constructor(el) {
        this.header = el;

        this.init();
    }

    init() {
        this.body = $('body');

        if ($('.header--lite').length || $('.header--2').length) {
            return;
        }

        if (this.listening || !this.header.length) {
            return;
        }

        // do first data update
        this.updateData(true);

        this.scroll();

        this.win.resize(debounce(() => {
            this.update();
        }, 120));

        // bind on resize size changes (RWD)
        this.win.resize(debounce(() => {
            this.lock();

            if (this.pinned) {
                this.header.removeClass('pinned anim');
                this.headerHeight = this.getHeaderHeight();
                this.header.addClass('pinned');
                this.applyRoom();
            } else {
                this.updateData();
            }

            this.unlock();
        }, 200));
    }

    // do scroll loop
    scroll() {
        // Avoid not needed calculations
        if (this.stoped || this.lastPosition === window.pageYOffset) {
            this.rafId = window.requestAnimationFrame(() => this.scroll());
            return false;
        } else {
            this.lastPosition = window.pageYOffset | 0;
        }

        if (this.lastPosition >= this.offsetUpY && !this.pinned) {
            // avoid exceeding doc bounds (bouncing issue)
            if ((this.lastPosition + this.headerHeight + this.win.height()) < this.doc.height()) {
                this.header.addClass('pinned anim');
                this.applyRoom();
                this.pinned = true;
                this.win.trigger('pin');
            }
        } else if (this.lastPosition <= this.offsetDownY && this.pinned) {
            this.header.removeClass('pinned anim');
            this.body.css('paddingTop', '');
            this.pinned = false;
            this.win.trigger('unpin');
        }

        // request
        this.rafId = window.requestAnimationFrame(() => this.scroll());
    };

    lock() {
        return this.stoped = true;
    }

    unlock() {
        return this.stoped = false;
    }

    update() {
        // first try (force unpin)
        this.updateData();
        // last trial (raf and css animations coordination)
        (this.update = () => {
            // back to previous state (if were pinned)
            if (!this.pinned) {
                this.updateData();
                return;
            }
            window.setTimeout(this.update, 100);
        })();
    }

    //
    // internal functions
    //

    // updateData: pre calculate data to get better perfs
    updateData(forceRecalc) {
        this.lastPosition = forceRecalc ? -1 | 0 : this.lastPosition; // Force a recalculation if set
        this.headerOffsetY = this.header.offset().top | 0;
        this.headerHeight = this.getHeaderHeight();
        this.offsetUpY = (this.headerOffsetY + this.offset + this.headerHeight) | 0;
        this.offsetDownY = (this.headerOffsetY + this.headerHeight) | 0;
    }

    // apply top room compensatory space
    applyRoom() {
        const currPad = Math.round(parseFloat(this.body.css('paddingTop')));
        if (this.headerHeight !== currPad) {
            this.body.css('paddingTop', this.headerHeight);
        }
    }

    //
    // helpers
    //

    getHeaderHeight() {
        return Math.round(parseFloat(this.header.not('.pinned').outerHeight())) || this.headerHeight;
    }
}
